import { Component, OnInit, HostListener } from '@angular/core';
import { HudComponent } from '../hud/hud.component';
import { FooterComponent } from '../footer/footer.component';
@Component({
    selector: 'app-terms-and-conditions',
    templateUrl: './terms-and-conditions.component.html',
    styleUrls: ['./terms-and-conditions.component.css'],
    imports: [HudComponent, FooterComponent]
})
export class TermsAndConditionsComponent implements OnInit {
  showCharacters = false;
  french = false;

  ngOnInit() {
    if (window.innerWidth > 1660) {
      this.showCharacters = true;
    }
    const userLang = navigator.language;
    this.french = userLang == "fr" || userLang == "fr-FR";
  }

  OnClickFr() {
    this.french = true;
  }
  OnClickEn() {
    this.french = false;
  }

  @HostListener("window:resize", [])
  onResize() {
    const width = window.innerWidth;
    this.showCharacters = width > 1660;
  }
}
